import { render, staticRenderFns } from "./igt-card-reveal-modal.vue?vue&type=template&id=e424259c&scoped=true&"
import script from "./igt-card-reveal-modal.vue?vue&type=script&lang=js&"
export * from "./igt-card-reveal-modal.vue?vue&type=script&lang=js&"
import style0 from "./igt-card-reveal-modal.vue?vue&type=style&index=0&id=e424259c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e424259c",
  null
  
)

export default component.exports